import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
  OnDestroy,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  NgZone,
} from '@angular/core';
import { SortHeadComponent } from '../_common/sort-head/sort-head.component';
import {
  CursorMode,
  MessageType,
  SortHeadType,
  SubmitType,
  IFormResponse,
} from '../../../_interfaces/entity';
import { CommonModule, DecimalPipe } from '@angular/common';
import {
  Formio,
  FormioComponent,
  FormioModule,
  FormioSubmissionCallback,
} from '@formio/angular';
import { ImageComponent } from './image/image.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../_services/shared.service';
import { ApiService } from '../../../_services/api.service';
import { IDropdown, IPackage } from '../../../_interfaces/packageList';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';

enum FormIOStage {
  STAGE1,
  STAGE2,
}
enum FormIOAPICallStage {
  INITIAL,
  STARTED,
  COMPLETED,
  FAILED,
}

@Component({
  selector: 'app-foi',
  standalone: true,
  imports: [SortHeadComponent, CommonModule, FormioModule, ImageComponent],
  providers: [DecimalPipe],
  templateUrl: './foi.component.html',
  styleUrl: './foi.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FoiComponent implements OnInit, OnDestroy {
  baseUrl: string = environment.baseUrl;
  formioLookupForm: string = `${environment.formio.baseUrl}${environment.formio.lookupFormName}`;
  formioSubmissionForm: string = '';
  formSubmissionData: any = {};
  formDefinition: any = {};
  formLookupData: Object = {};
  formIOStage: FormIOStage = FormIOStage.STAGE1;
  formIOAPICallStage: FormIOAPICallStage = FormIOAPICallStage.INITIAL;
  disableButtons: boolean = false;
  // doctypes: IDocType[] = [];
  previewImage: any = { docIndex: '', fileIndex: '', url: '' };
  selectedElement!: HTMLInputElement;
  rotations: number[] = [];
  currentRotateState: number = 0;
  zoomLevel: number = 1;
  @ViewChild('previewBox', { static: true }) previewBoxEl!: ElementRef;
  previewWidth: number = 100;
  @ViewChild('formiobox', { static: true }) formioboxEl!: ElementRef;
  packageDBId: string = '';
  percentage: number = 0;
  package: IPackage;
  isShowCopiedNotification: boolean = false;
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  sharedService = inject(SharedService);
  apiService = inject(ApiService);
  ngZone = inject(NgZone);
  selectedPage: number = 1;
  flattenArray: any = [];
  selectedDoc: string = '';
  decimalPipe = inject(DecimalPipe);
  isSubmitButtonEnabled: boolean = false;
  preventSaveCallOnDestroy: boolean = false;
  concurrencySubscription: Subscription = new Subscription();
  logoutSubscription: Subscription = new Subscription();
  submissionFormTitle: string = '';
  formDefinistionSubmissionData: Object = {};
  submissionFormioObject!: FormioComponent;
  cursorMode: CursorMode = CursorMode.ZOOM;
  isArchived: boolean = false;
  @Input() isCourtexView: boolean = false;
  
  // Angeion form properties
  angeionFormType: string = '';
  angeionFormLocation: string = '';
  angeionFormName: string = '';
  angeionFormCacheKey: string = '';
  angeionFormIframe: HTMLIFrameElement | null = null;
  angeionFormMessageListener: ((event: MessageEvent) => void) | null = null;
  angeionFormSubmissionPending: boolean = false;
  angeionFormSubmissionResolver: ((value: any) => void) | null = null;
  angeionFormSubmissionRejecter: ((reason: any) => void) | null = null;

  @ViewChild(SortHeadComponent, { static: true })
  sortHeadComponent!: SortHeadComponent;

  constructor() {
    this.package = {
      activityDTOs: [],
      anPackageDocumentDTOs: [],
      anPackageDocumentTypeDTOs: [],
      caseId: '',
      caseName: '',
      claimId: '',
      coderId: '',
      coderName: '',
      createdBy: '',
      createdDateTime: '',
      id: '',
      lastUpdateDate: '',
      lastUpdatedBy: '',
      packageId: '',
      percentageDocExtraction: '',
      percentageOfDocClassification: '',
      sourceSystem: '',
      status: '',
      submissionId: '',
      timeForDocClassification: '',
      timeForDocExtraction: '',
      updatedBy: '',
      updatedDateTime: '',
      isClassified: false,
      formioId: '',
      formioName: '',
      page: '',
      packageEvent: '',
    };
    this.concurrencySubscription = this.sharedService.showConcurrency.subscribe(
      (val) => {
        if (val) {
          this.preventSaveCallOnDestroy = true;
        }
      }
    );

    this.logoutSubscription = this.sharedService.logout.subscribe((val) => {
      if (val) {
        if (this.router?.url.includes('foi')) {
          console.log(
            'foi logout',
            this.activatedRoute.snapshot.routeConfig?.path
          );
          this.package.page = '';
          this.onSaveClick(true, false, true);
          this.preventSaveCallOnDestroy = true;
          this.sharedService.logout.next(false);
        }
      }
    });
  }
  // beforeSubmitHandler!: (submission: object, callback: FormioSubmissionCallback) => void
  // submissionFormOptions = {
  //   hooks: { beforeSubmit: this.beforeSubmitSubmissionForm.bind(this) },
  // };
  ngOnInit(): void {
    if (this.router.url && this.router.url.includes('archives')) {
      this.isArchived = true;
    }
    // this.beforeSubmitHandler = this.beforeSubmitSubmissionForm.bind(this);

    if (this.activatedRoute.snapshot.paramMap.get('readonly') == 'readonly') {
      this.sharedService.readOnlyMode.set(true);
      this.sharedService.showToastMessage({
        message: 'You are now in Read Only mode.',
        type: MessageType.info,
      });
    } else {
      if (this.isCourtexView) {
        this.sharedService.readOnlyMode.set(true);
      } else {
        this.sharedService.readOnlyMode.set(false);
      }
    }
    if (this.isCourtexView) {
      this.packageDBId =
        this.activatedRoute.snapshot.paramMap.get('packageId') || '';
    } else {
      this.packageDBId =
        this.activatedRoute.parent?.snapshot.paramMap.get('packageId') || '';
    }

    // this.previewImage =
    //   this.package.anPackageDocumentTypeDTOs[0].files[0].images[0];
    this.loadPackage();

    this.previewWidth = (<HTMLElement>(
      this.previewBoxEl.nativeElement
    )).offsetWidth;
    this.initializeRotations();
  }
  ngOnDestroy(): void {
    if (!this.preventSaveCallOnDestroy) {
      this.package.page = '';
      this.onSaveClick(false, false, true);
    }
    
    // Clean up subscriptions
    this.concurrencySubscription.unsubscribe();
    this.logoutSubscription.unsubscribe();
    
    // Clean up Angeion form iframe and message listener
    this.cleanupAngeionFormIframe();
  }

  loadPackage() {
    let pageCount = 0;
    this.sharedService.showLoading();
    let packageBaseUrl = 'package';
    if (this.isArchived) {
      packageBaseUrl = 'package/archived';
    }
    let getPackageUrl = `${packageBaseUrl}/document/get-by-package/${this.packageDBId}`;
    if (this.isCourtexView) {
     
   
      getPackageUrl = `${packageBaseUrl}/get-by-package/${atob(
        this.packageDBId
      )}`;
    }
    this.apiService.get(getPackageUrl).subscribe({
      next: (response) => {
        this.package = response.data;
        if (this.package.status) {
          this.package.status = this.package.status.toUpperCase();
        }
        if (this.package.status == 'ON_HOLD') {
          this.package.status = 'WORK_IN_PROGRESS';
          this.package.page = '';
          this.onSaveClick(true, false, true);
        }

            if (
          !this.package.coderId &&
          this.package.status == 'NEW' && this.package.isClassified && this.package.percentageOfDocClassification == '100'  &&
          !this.sharedService.readOnlyMode()
        ) {
          this.selfAssign();
        }

        this.percentage = this.package.percentageDocExtraction
          ? parseInt(this.package.percentageDocExtraction)
          : 0;

        this.sharedService.selectedPackage.set(this.package);
        if (this.package.anPackageDocumentTypeDTOs) {
          this.package.anPackageDocumentTypeDTOs?.forEach((e, docIndex) => {
            if (e?.files?.length) {
              e.files.forEach((file, fileIndex) => {
                if (file?.images?.length) {
                  file.images.forEach((image, pageIndex) => {
                    pageCount++;
                    this.flattenArray.push({
                      docIndex,
                      fileIndex,
                      pageIndex,
                      image,
                      pageCount,
                    });
                  });
                  if (!this.previewImage?.url) {
                    e.isExpand = true;
                    file.isExpand = true;
                    let packageBaseUrl = 'package';
                    if (this.isArchived) {
                      packageBaseUrl = 'package/archived';
                    }
                    this.previewImage = {
                      docIndex,
                      fileIndex,
                      pageIndex: 0,
                      url: `${this.baseUrl}${packageBaseUrl}/document/get-by-package/download/${this.package.id}/${file.images[0]}`,
                    };
                    this.selectedDoc =
                      this.package.anPackageDocumentTypeDTOs[docIndex].name;
                  }
                }
              });
            }
          });
        }
        this.formLookupData = {
          data: {
            zero_zero_id: this.package.claimId,
            case_id: this.package.caseId,
          },
        };
        if (this.package.claimId && this.package.claimId != 'unknown') {
          this.retriveCaseFormId({});
        }
      },
      error: (err) => {
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
        this.sharedService.hideLoading();
      },
      complete: () => {
        this.sharedService.hideLoading();
      },
    });
  }

   selfAssign() {
    this.apiService.put(`package/${this.package.id}/assign/self`).subscribe({
      next: (respose) => {
        if (respose.success == 'true') {
          this.sharedService.showToastMessage({
            message: `Package assigned to ${
              this.sharedService.loginUser().user.first_name
            } ${this.sharedService.loginUser().user.last_name}`,
            type: MessageType.info,
          });
        }
      },
      error: (err) => {
        console.log({ err });
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
      },
      complete: () => {},
    });
  }

  get SortHeadType() {
    return SortHeadType;
  }

  setEventListerner(form: FormioComponent) {
    console.log({ form });
    if (form) {
      this.submissionFormioObject = form;
      if (
        this.submissionFormioObject?.submission?.data?.metadata?.zero_zero_id
      ) { 
        this.submissionFormioObject.submission.data.metadata.zero_zero_id =
        this.package.claimId;
      }
    }
    if (form?.submission?.data) {
      this.formSubmissionData = form.submission;
    }

    if (form?.label) {
      this.submissionFormTitle = form.label;
    }
      form.options = {
      hooks: {
        beforeSubmit: this.handleBeforeSubmit.bind(this),
      },
    };

    //this.addEventsForSelecttedEelemts();
  }

  /* addEventsForSelecttedEelemts() {
     setTimeout(() => {
      const formIOEl: HTMLElement = this.formioboxEl
        .nativeElement as HTMLElement;
      if (formIOEl) {
        formIOEl
          .querySelectorAll('.formio-component-container')
          .forEach((el) => {
            el.querySelectorAll('input').forEach((element) => {
              if (element) {
                (<HTMLInputElement>element).addEventListener(
                  'click',
                  (event) => {
                    if (event?.target instanceof HTMLInputElement) {
                      console.log(event.target, 'event.target');
                      this.selectedElement = event.target as HTMLInputElement;
                      console.log(this.selectedElement, 'this.selectedElement');
                      this.setSelectedElement(this.selectedElement);
                    }
                  }
                );
              }
            });
            el.querySelectorAll('textarea').forEach((element) => {
              if (element) {
                element.addEventListener('click', (event) => {
                  if (event?.target instanceof HTMLInputElement) {
                    this.selectedElement = event.target as HTMLInputElement;
                    this.setSelectedElement(this.selectedElement);
                  }
                });
              }
            });
          });
          el.querySelectorAll('textarea').forEach((element) => {
            if (element) {
              element.addEventListener('click', (event) => {
                if (event?.target instanceof HTMLInputElement) {
                  this.selectedElement = event.target as HTMLInputElement;
                  this.setSelectedElement(this.selectedElement);
                }
              });
            }
          });
        });
      }
    }, 1000); 
  } */

  setSelectedElement(selectElement: HTMLInputElement) {
    const formIOEl: HTMLElement = this.formioboxEl.nativeElement as HTMLElement;
    if (formIOEl) {
      formIOEl.querySelectorAll('input').forEach((element) => {
        if (element) {
          element.style.border = '';
        }
      });
      formIOEl.querySelectorAll('textarea').forEach((element) => {
        if (element) {
          element.style.border = '';
        }
      });
    }
    if (selectElement) {
      if (selectElement) {
        selectElement.style.border =
          '1px solid var(--foi-doctype-tree-bg-color)';
      }
    }
  }

  calculatePercentage(submissionData: any) {
    console.log('calculatePercentage');

    if (submissionData) {
      Object.keys(submissionData).forEach((key) => {
        // console.log({ key });
        // console.log(submissionData[key]);
      });
    }
  }
  onTextSelect(text: string) {
    if (text) {
      if (this.selectedElement && !this.selectedElement.value) {
        this.selectedElement.value = text;
        const name = this.selectedElement.getAttribute('name');
        const properties = (<string>name).split(/\[|\]/).filter(Boolean);

        let target = this.formSubmissionData;
        console.log({ target });

        for (let i = 0; i < properties.length - 1; i++) {
          if (target[properties[i]]) {
            target = target[properties[i]];
          }
        }

        // Set the value to the target property
        target[properties[properties.length - 1]] = text;
        // this.formSubmissionData = JSON.parse(JSON.stringify(target));
        this.calculatePercentage(target);
      } else {
        navigator.clipboard.writeText(text);
        this.showCopiedNotification();
      }
    }
    // const formIOEl: HTMLElement = this.formioboxEl.nativeElement as HTMLElement;
    // if (formIOEl) {
    //   console.log(formIOEl.querySelectorAll('.formio-form-group'));
    //   formIOEl.querySelectorAll('.formio-form-group').forEach((el) => {
    //     console.log({ el });
    //   });
    //   console.log(document.activeElement);
    // }
  }
  initializeRotations() {
    this.rotations = [0, Math.PI / 2, Math.PI, (3 * Math.PI) / 2];
  }
  rotateProcess() {
    this.currentRotateState++;
    if (this.currentRotateState >= this.rotations.length) {
      this.currentRotateState = 0;
    }
  }

  zoomIn() {
    this.zoomLevel *= 1.2; // Adjust the zoom factor as needed
  }

  zoomOut() {
    this.zoomLevel /= 1.2; // Adjust the zoom factor as needed
  }
  onFinalFormSubmit(data: any) {
    this.isSubmitButtonEnabled = true;
  }

  retriveCaseFormId(formioData: any) {
    console.log({ formioData });
    //Assigning claim id
    //TODO: there may be a change in field formioData?.data?.notice_id
    //ABC00001
    if (formioData?.data?.zero_zero_id) {
      this.package.claimId = formioData?.data?.zero_zero_id;
      this.package.page = '';
      this.onSaveClick(true, false, true);
    }

    this.sharedService.showLoading();
    //TODO: remove caseId hard coding.
    // this.package.caseId = '1';
    this.apiService
      .post('api/integration/courtex/generic-api', {
        path: `/api/v1/cases/${this.package.caseId}/form`,
        method: 'GET',
        input: {},
      })
      .subscribe({
        next: (response) => {
          console.log({ response });
          if (response?.success == 'true') {
            if (typeof response.data === 'object') {
              const formData: IFormResponse = response?.data?.data;
              
              // Check form_type to determine which form to load
              const formType = formData?.form_type;
              
              if (formType === 'angeion') {
                // Handle Angeion form
                this.angeionFormType = formType;
                this.angeionFormLocation = formData.form_location || '';
                this.angeionFormName = formData.form_name || '';
                this.angeionFormCacheKey = formData.form_cache_key || '';
                
                console.log('Loading Angeion form:', {
                  type: this.angeionFormType,
                  location: this.angeionFormLocation,
                  name: this.angeionFormName,
                  cacheKey: this.angeionFormCacheKey
                });
                
                this.loadAngeionForm();
              } else {
                // Default FormIO behavior (formType === 'formio' or undefined)
                this.package.formioId = formData?.formio_id || '';
                this.package.formioName = formData?.form_name || '';
                console.log(this.package);
                
                this.retriveClaimSubmissionId();
              }
            } else {
              this.sharedService.showToastMessage({
                message: response.data,
                type: MessageType.info,
              });
            }
          }
        },
        error: (err) => {
          console.log({ err });
          this.sharedService.hideLoading();
        },
        complete: () => {
          this.sharedService.hideLoading();
        },
      });
  }
  retriveClaimSubmissionId() {
    this.sharedService.showLoading();
    this.apiService
      .post('api/integration/courtex/generic-api', {
        path: `/api/v2/claims/zero_zero_id/${this.package.claimId}`,
        method: 'GET',
        input: {},
      })
      .subscribe({
        next: (response) => {
          console.log({ response });
          if (response?.success == 'true') {
            this.package.submissionId =
              response?.data?.data?.formio_submission_id;
          } else {
            this.formSubmissionData = {
              data: {
                metadata: {
                  zero_zero_id: this.package.claimId,
                  case_id: this.package.caseId,
                },
              },
            };
          }

          this.prepareSubmissionForm().then(() => {
            if (this.package.submissionId) {
              this.loadSubmissionData();
            } else {
              this.formDefinistionSubmissionData = {
                data: {
                  metadata: {
                    zero_zero_id: this.package.claimId,
                    case_id: this.package.caseId,
                  },
                },
              };
              this.onSaveClick(true, false, true);
            }
          });
        },
        error: (err) => {
          console.log({ err });
          this.sharedService.hideLoading();
          this.prepareSubmissionForm();
          //TODO: set default zero_zero_id as claim id, as API returns 404 error
          this.formSubmissionData = {
            data: {
              metadata: {
                zero_zero_id: this.package.claimId,
                case_id: this.package.caseId,
              },
            },
          };
        },
        complete: () => {
          this.sharedService.hideLoading();
        },
      });
  }

  prepareSubmissionForm() {
    return new Promise((resolve, reject) => {
      this.formIOStage = FormIOStage.STAGE2;
      this.formioSubmissionForm = `${environment.formio.baseUrl}${this.package.formioName}`;
      if (this.package.submissionId) {
        // this.formioSubmissionForm = `${environment.formio.baseUrl}${this.package.formioName}/submission/${this.package.submissionId}`;
      }
      this.formioSubmissionForm = `${this.formioSubmissionForm}`;
      this.apiService
        .formGet(`${this.formioSubmissionForm}`, {
          'X-Jwt-Token': `${this.sharedService.loginUser().formio_jwt}`,
        })
        .subscribe({
          next: (formDefinition) => {
            console.log({ formDefinition });
            formDefinition = this.removeValidation(formDefinition);
            formDefinition.action = null;
            // store the definition on this controller for use by the template
            this.formDefinition = formDefinition;
            // this.formDefinistionSubmissionData = {
            //   data: {
            //     metadata: {
            //       zero_zero_id: this.package.claimId,
            //       case_id: this.package.caseId,
            //     },
            //   },
            // };
            // if(this.package.submissionId) {
            //   this.loadSubmissionData();
            // }
          },
          error: (err) => {
            console.log({ err });
            reject(false);
          },
          complete: () => {
            console.log('prepareSubmissionForm completed');
            resolve(true);
          },
        });
    });
  }
  loadSubmissionData() {
    this.apiService
      .formGet(
        `${environment.formio.baseUrl}${this.package.formioName}/submission/${this.package.submissionId}`,
        {
          'X-Jwt-Token': `${this.sharedService.loginUser().formio_jwt}`,
        }
      )
      .subscribe({
        next: (formDefinistionSubmissionData) => {
          this.formDefinistionSubmissionData = formDefinistionSubmissionData;
          this.formDefinition.readOnly = !this.formDefinition.readOnly;

          //this.onSaveClick(true, false, true);
        },
        error: (err) => {
          console.log({ err });
        },
        complete: () => {
          console.log('loadSubmissionData completed');
        },
      });
  }

  onSubmit(submitType: SubmitType) {
    if (this.formIOStage == FormIOStage.STAGE2) {
      if (this.isAngeionForm()) {
        // Handle Angeion form submission directly
        this.handleAngeionSubmit(submitType);
        return;
      } else {
        // Handle FormIO submission
        this.formIOAPICallStage = FormIOAPICallStage.STARTED;
        this.triggerFormioSubmit(true);
      }
    }

    // Only set up the interval for FormIO forms
    if (!this.isAngeionForm()) {
      const interval = setInterval(() => {
        if (this.formIOAPICallStage == FormIOAPICallStage.COMPLETED) {
          clearInterval(interval); // Stop the interval
          this.onSubmitAfterSave(submitType);
          // Call your second function logic here
        } else if (this.formIOAPICallStage == FormIOAPICallStage.FAILED) {
          this.sharedService.showToastMessage({
            message: 'Submission failed',
            type: MessageType.error,
          });
          clearInterval(interval);
        }
      }, 100); // Check the flag every 100 milliseconds
    }
  }
  onSubmitAfterSave(submitType: SubmitType) {
    // this.onSaveClick(true);
    this.preventSaveCallOnDestroy = true;
    this.sharedService.showLoading();

    this.package.percentageDocExtraction = this.percentage.toString(); //update percentage

    const timer = this.sortHeadComponent.timer;
    this.package.timeForDocExtraction =
      this.decimalPipe.transform(timer.hours, '2.0') +
      ':' +
      this.decimalPipe.transform(timer.minutes, '2.0') +
      ':' +
      this.decimalPipe.transform(timer.seconds, '2.0'); //update time

    this.sharedService.selectedPackage.set(this.package);
    // this.package.status = 'COMPLETED';
    let packageTemp = JSON.parse(JSON.stringify(this.package));
    delete packageTemp.activityDTOs;
    delete packageTemp.anPackageDocumentDTOs;
    delete packageTemp.anPackageDocumentTypeDTOs;
    delete packageTemp.anPackageContactHistoryIdStatus;
    this.apiService
      .put(`package/${this.package.packageId}/submit`, packageTemp)
      .subscribe({
        next: (respose) => {
          console.log({ respose });
          if (respose.success == 'true') {
            this.sharedService.showToastMessage({
              message: 'Thank you! Your submission was successful.',
              type: MessageType.success,
            });
            switch (submitType) {
              case SubmitType.SUBMIT:
                this.router.navigate(['/packages', '1']);
                break;
              case SubmitType.SUBMIT_AND_GETNEXT:
                this.getNextPackage();
                break;
              default:
                this.router.navigate(['/packages', '1']);
            }
          } else {
            this.sharedService.showToastMessage({
              message:
                respose.message ||
                'Document processing failed. Please submit again',
              type: MessageType.error,
            });
          }
        },
        error: (err) => {
          this.sharedService.showToastMessage({
            message:
              'Document processing encountered an error. Please resubmit.',
            type: MessageType.error,
          });
          this.sharedService.hideLoading();
        },
        complete: () => {
          this.sharedService.hideLoading();
        },
      });
  }

  getNextPackage() {
    //package/next-package
    console.log(this.sharedService.loginUser());
    console.log(this.sharedService.filter().caseId);

    if (!this.sharedService.filter().caseId) {
      const selectedCaseId = JSON.parse(
        localStorage.getItem('selectedCase') || '{}'
      ) as IDropdown;
      if (selectedCaseId.id) {
        this.sharedService.filter().caseId = selectedCaseId.id;
      }
    }

    const userDetails = {
      email: '',
      lastName: this.sharedService.loginUser().user.last_name,
      firstName: this.sharedService.loginUser().user.first_name,
      anCourtexUserDetails: {
        id: this.sharedService.loginUser().user.id,
        firstName: this.sharedService.loginUser().user.first_name,
      },
      caseId: this.sharedService.filter().caseId,
    };

    this.sharedService.showLoading();
    this.apiService.put(`package/next-package`, userDetails).subscribe({
      next: (response) => {
        if (response.success === 'true') {
          // if (!response.data?.hasNewPackage) {
          //   this.sharedService.showToastMessage({
          //     message: 'No new package is available',
          //     type: MessageType.error,
          //   });
          //   return;
          // }
          const packageItem = response.data;
          if (!packageItem.isClassified) {
            this.router.navigate([
              '/packages',
              packageItem.id,
              'classification',
            ]);
          } else {
            this.router.navigate(['/packages', packageItem.id, 'foi']);
          }
        } else {
          this.sharedService.showToastMessage({
            message:
              response.message ||
              'There is no new package available to assign.',
            type: MessageType.info,
          });
          this.router.navigate(['/packages', '1']);
        }
      },
      error: (err) => {
        console.log({ err });
        this.sharedService.hideLoading();
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
      },
      complete: () => {
        this.sharedService.hideLoading();
      },
    });
  }
  showCopiedNotification() {
    this.isShowCopiedNotification = true;
    setTimeout(() => {
      this.isShowCopiedNotification = false;
    }, 1000);
  }
  showZoomLevel(val: number) {
    return Math.floor(val * 100);
  }

  get FormIOStage() {
    return FormIOStage;
  }
  triggerFormioSubmit(isSubmitForm: boolean) {
    if (this.isAngeionForm()) {
      // Handle Angeion form submission
      if (isSubmitForm) {
        this.submitAngeionForm()
          .then((response) => {
            console.log('Angeion form submitted:', response);
            this.formIOAPICallStage = FormIOAPICallStage.COMPLETED;
            this.sharedService.showToastMessage({
              message: 'Form submitted successfully.',
              type: MessageType.success,
            });
          })
          .catch((error) => {
            console.error('Angeion form submission failed:', error);
            this.formIOAPICallStage = FormIOAPICallStage.FAILED;
            this.sharedService.showToastMessage({
              message: 'Form submission failed. Please try again.',
              type: MessageType.error,
            });
          });
      }
    } else {
      // Handle FormIO submission (existing logic)
      const formIOEl: HTMLElement = this.formioboxEl.nativeElement as HTMLElement;
      if (formIOEl) {
        const btn = formIOEl.querySelector(
          'button[type="submit"]'
        ) as HTMLButtonElement;
        if (btn && isSubmitForm) {
          btn.click();
        }
      }
    }
  }
  onSaveClick(hideToast: boolean, isBack: boolean, isSubmitForm: boolean) {
    if (
      this.isArchived ||
      this.sharedService.readOnlyMode() ||
      this.package.status == 'COMPLETED' ||
      this.package.status == 'CANCELLED'
    ) {
      return;
    }
    // if (this.submissionFormioObject) {
    //   console.log(this.submissionFormioObject.submission);
    //   this.handleBeforeSubmit(
    //     this.submissionFormioObject.submission,
    //     function (error, submission) {}
    //   );
    //   // this.submissionFormioObject.;
    // }
    if (this.formIOStage == FormIOStage.STAGE2) {
      if (this.isAngeionForm() && isSubmitForm) {
        // Handle Angeion form submission
        this.submitAngeionFormAndSave(hideToast, isBack);
        return;
      } else {
        this.triggerFormioSubmit(isSubmitForm);
      }
    }
    // For non-Angeion forms or when not submitting, handle the regular save
    this.savePackageData(hideToast, isBack);
  }

  /**
   * Saves the package data to the server
   */
  savePackageData(hideToast: boolean, isBack: boolean) {
    this.sharedService.showLoading();

    this.package.percentageDocExtraction = this.percentage.toString(); //update percentage

    const timer = this.sortHeadComponent.timer;
    this.package.timeForDocExtraction =
      this.decimalPipe.transform(timer.hours, '2.0') +
      ':' +
      this.decimalPipe.transform(timer.minutes, '2.0') +
      ':' +
      this.decimalPipe.transform(timer.seconds, '2.0'); //update time

    // this.sharedService.selectedPackage.set(this.package);
    let packageTemp = JSON.parse(JSON.stringify(this.package));
    delete packageTemp.activityDTOs;
    delete packageTemp.anPackageDocumentDTOs;
    delete packageTemp.anPackageDocumentTypeDTOs;
    delete packageTemp.anPackageContactHistoryIdStatus;
    this.apiService.put('package', packageTemp).subscribe({
      next: (respose) => {
        this.disableButtons = false;
        if (respose?.success == 'true') {
          if (!hideToast) {
            this.sharedService.showToastMessage({
              message: 'Your edits have been saved successfully',
              type: MessageType.success,
            });
          }
          if (isBack) {
            if (this.isCourtexView) {
              this.router.navigateByUrl(`/dc/${this.packageDBId}`);
            } else {
              if (this.sharedService.readOnlyMode()) {
                this.router.navigateByUrl(
                  `/packages/${this.packageDBId}/classification/readonly`
                );
              } else {
                this.router.navigateByUrl(
                  `/packages/${this.packageDBId}/classification`
                );
              }
            }
          }
        }
      },
      error: (err) => {
        this.disableButtons = false;
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
        this.sharedService.hideLoading();
      },
      complete: () => {
        this.sharedService.hideLoading();
      },
    });
  }

  movePreview(next: boolean) {
    // Reset Rotation
    this.currentRotateState = 0;
    // Reset Zoom leve
    this.zoomLevel = 1;

    let { docIndex, fileIndex, pageIndex } = this.previewImage;
    let currentDoc = docIndex;
    let currentFile = fileIndex;
    let currentImage = '';

    let flattenIndex = this.flattenArray.findIndex(
      (item: any) =>
        item.docIndex === docIndex &&
        item.fileIndex === fileIndex &&
        item.pageIndex === pageIndex
    );
    if (next) {
      flattenIndex++;
    } else {
      flattenIndex--;
    }
    if (flattenIndex > -1 && flattenIndex <= this.flattenArray.length - 1) {
      let flattenObj = this.flattenArray[flattenIndex];
      currentDoc = flattenObj.docIndex;
      currentFile = flattenObj.fileIndex;
      pageIndex = flattenObj.pageIndex;
      currentImage = flattenObj.image;
      this.package.anPackageDocumentTypeDTOs[currentDoc].isExpand = true;
      this.package.anPackageDocumentTypeDTOs[currentDoc].files[
        currentFile
      ].isExpand = true;
      this.selectedDoc =
        this.package.anPackageDocumentTypeDTOs[currentDoc].name;
      this.formPreviewImage(
        currentDoc,
        currentFile,
        pageIndex,
        currentImage,
        flattenObj.pageCount
      );
    }
  }

  formPreviewImage(
    docIndex: number,
    fileIndex: number,
    pageIndex: number,
    url: string,
    selectedPage?: number
  ) {
    // Reset Rotation
    this.currentRotateState = 0;
    // Reset Zoom leve
    this.zoomLevel = 1;
    if (selectedPage) {
      this.selectedPage = selectedPage;
    } else {
      let flattenObj = this.flattenArray.find(
        (item: any) =>
          item.docIndex === docIndex &&
          item.fileIndex === fileIndex &&
          item.pageIndex === pageIndex
      );
      this.selectedPage = flattenObj ? flattenObj.pageCount : 1;
    }
    this.selectedDoc = this.package.anPackageDocumentTypeDTOs[docIndex].name;
    let packageBaseUrl = 'package';
    if (this.isArchived) {
      packageBaseUrl = 'package/archived';
    }
    const baseURL =
      this.baseUrl +
      `${packageBaseUrl}/document/get-by-package/download/` +
      this.package.id +
      '/';
    if (docIndex > -1 && fileIndex > -1 && pageIndex > -1 && url) {
      this.previewImage = {
        docIndex,
        fileIndex,
        pageIndex,
        url: baseURL + url,
      };
    }
  }

  navigateToDC() {
    this.preventSaveCallOnDestroy = true;
    this.package.page = '';
    this.onSaveClick(true, true, true);

    // if (
    //   this.isArchived ||
    //   this.sharedService.readOnlyMode() ||
    //   this.package.status == 'COMPLETED' ||
    //   this.package.status == 'CANCELLED'
    // ) {
    // }
    let packageBaseUrl = 'packages';
    if (this.isArchived) {
      packageBaseUrl = 'archived-packages';
    }
    if (this.sharedService.userview() == 'userview') {
      this.router.navigateByUrl(
        `/${packageBaseUrl}/${this.sharedService.packageListPageNumber()}/userview`
      );
    } else {
      // this.router.navigateByUrl(
      //   `/${packageBaseUrl}/${this.sharedService.packageListPageNumber()}`
      // );
      if(this.sharedService.readOnlyMode()) {
        this.router.navigateByUrl(
          `/${packageBaseUrl}/${this.packageDBId}/classification/readonly`
        );
        return;
      }
      this.router.navigateByUrl(`/${packageBaseUrl}/${this.packageDBId}/classification/`);
    }
  }
  onFormIoValueChange(data: any) {
    console.log({ data });

    if (data?.data) {
      // this.formSubmissionData = data;
      this.calculatePercentage(data.data);
    }
  }
  // beforeSubmitSubmissionForm(
  //   submission: object,
  //   callback: FormioSubmissionCallback
  // ) {
  //   console.log({ submission });
  //   this.apiService
  //     .formPost(`${this.formioSubmissionForm}`, JSON.stringify(submission), {
  //       'X-Token': `${environment.formio.noValidate}`,
  //       // 'X-Jwt-Token': `${this.sharedService.loginUser().formio_jwt}`,
  //       'Content-Type': 'application/json',
  //     })
  //     .subscribe({
  //       next(response) {
  //         console.log({ response });
  //       },
  //       error(err) {
  //         console.log({ err });
  //       },
  //       complete() {
  //         console.log('complete');
  //       },
  //     });
  // }
  // onBeforeSubmit(data: any) {
  //   console.log({ data });
  //   return false;
  // }

  /**
   * A helper method to remove validation from the form.io submission object
   */
  removeValidation(obj: any): any {
    // Remove these keys from every object in the tree
    const keysToRemove = ['validate', 'required', 'minYear', 'maxYear'];

    // Check if the input is an array
    if (Array.isArray(obj)) {
      return obj.map((item) => this.removeValidation(item));
    }
    // Check if the input is an object
    else if (typeof obj === 'object' && obj !== null) {
      return Object.keys(obj).reduce((newObj: any, key) => {
        if (!keysToRemove.includes(key)) {
          // Recursively apply the function to nested objects or arrays
          newObj[key] = this.removeValidation(obj[key]);
        }
        return newObj;
      }, {});
    }
    // Return the value directly if it's neither an object nor an array
    else {
      return obj;
    }
  }

  async handleBeforeSubmit(
    submission: any,
    callback: FormioSubmissionCallback
  ) {
    if (this.sharedService.readOnlyMode()) return;
    if (this.package.status == 'COMPLETED') {
      this.sharedService.showToastMessage({
        message:
          'Package already submitted to Courtex. Cannot save form data again.',
        type: MessageType.info,
      });
      this.formDefinition.readOnly = !this.formDefinition.readOnly;
      return;
    }


    // TODO: replace with your actual value (only when you receive a submission ID from the 'get claim details by zero zero id' endpoint)
    let EXISTING_SUBMISSION_ID = this.package.submissionId;

    // determine the courtex URL to post to for this request
    const courtexUrl = EXISTING_SUBMISSION_ID
      ? `/api/v1/formio/submission/${EXISTING_SUBMISSION_ID}?form_url=${this.formioSubmissionForm}`
      : `/api/v1/formio/submission?form_url=${this.formioSubmissionForm}`;
    this.sharedService.showLoading();
    this.apiService
      .post(`api/integration/courtex/generic-api`, {
        path: courtexUrl,
        method: 'POST',
        input: submission,
        headers: {
          // authentication for the form.io api
          'X-Jwt-Token': this.sharedService.loginUser().formio_jwt,
          // Authorization: this.sharedService.loginUser().courtex_jwt,
        },
      })
      .subscribe({
        next: (response) => {
          this.disableButtons = false;
          if (typeof response.data === 'object') {
            this.formDefinition.readOnly = !this.formDefinition.readOnly;
            this.isSubmitButtonEnabled = true;
            this.sharedService.showToastMessage({
              message: 'Successfully saved',
              type: MessageType.success,
            });
            this.package.submissionId = response.data._id;
            this.onSaveClick(true, false, false);
            this.formIOAPICallStage = FormIOAPICallStage.COMPLETED;
            callback(null as any, response.data);
          } else {
            // Error
            this.sharedService.showToastMessage({
              message: `Error: ${
                response.message || 'Form submission failed. Please try again!'
              }`,
              type: MessageType.error,
            });
            this.formIOAPICallStage = FormIOAPICallStage.FAILED;
            callback(
              {
                message: `Form IO error ${response.data}`,
                component: null as any,
              },
              {}
            );
          }
        },
        error: (err) => {
          this.disableButtons = false;
          this.sharedService.hideLoading();
          console.log({ err });
          callback(err as any, {});
          this.formIOAPICallStage = FormIOAPICallStage.FAILED;
        },
        complete: () => {
          this.disableButtons = false;
          console.log('submission form completed');
          this.formIOAPICallStage = FormIOAPICallStage.COMPLETED;
        },
      });
  }

  addClickEvent(field: any) {
    const fieldName = field?.target as HTMLInputElement;
    if (
      fieldName &&
      fieldName.tagName == 'INPUT' &&
      (fieldName.type == 'text' || fieldName.type == 'textarea')
    ) {
      this.selectedElement = fieldName;
      this.setSelectedElement(this.selectedElement);
    }
  }

  public get CursorMode() {
    return CursorMode;
  }
  toggleExtractCursor() {
    if (this.cursorMode == CursorMode.EXTRACT) {
      this.cursorMode = CursorMode.ZOOM;
    } else {
      this.cursorMode = CursorMode.EXTRACT;
    }
  }

  /**
   * Loads an Angeion form via iframe
   */
  async loadAngeionForm() {
    try {
      this.sharedService.showLoading();
      
      // Validate required property - only form_location is needed for iframe
      if (!this.angeionFormLocation) {
        throw new Error('Missing required form location');
      }
      
      console.log('Loading Angeion form via iframe:', {
        location: this.angeionFormLocation,
        name: this.angeionFormName
      });

      // Clean up any existing iframe
      this.cleanupAngeionFormIframe();

      // Get JWT token and zeroZeroId
      const jwtToken = this.sharedService.loginUser()?.formio_jwt;
      if (!jwtToken) {
        throw new Error('JWT token not available');
      }
      
      const zeroZeroId = this.package.claimId || '';
      
      // Build the iframe URL with query parameters
      const iframeSrc = `${this.angeionFormLocation}?zeroZeroId=${encodeURIComponent(zeroZeroId)}&jwtToken=${encodeURIComponent(jwtToken)}`;
      console.log('Iframe src:', iframeSrc);

      // Create the iframe element
      this.angeionFormIframe = document.createElement('iframe');
      this.angeionFormIframe.src = iframeSrc;
      this.angeionFormIframe.style.cssText = 'width: 100%; height: 100%; min-height: 1000px; border: none;';
      this.angeionFormIframe.setAttribute('title', 'Angeion Claim Form');
      
      // Set up the message listener for form submission
      this.setupAngeionFormMessageListener();
      
      // Get the form container element
      const formContainer = this.formioboxEl.nativeElement;
      
      // Clear existing content and append the iframe
      formContainer.innerHTML = '';
      formContainer.appendChild(this.angeionFormIframe);
      
      // Set the stage to STAGE2 to indicate form is loaded
      this.formIOStage = FormIOStage.STAGE2;
      
      console.log('Angeion form iframe loaded successfully');
      
    } catch (error) {
      console.error('Error loading Angeion form:', error);
      
      // Provide more specific error messages
      let errorMessage = 'Failed to load form';
      if (error instanceof Error) {
        errorMessage = `Form loading error: ${error.message}`;
      }
      
      this.sharedService.showToastMessage({
        message: errorMessage,
        type: MessageType.error,
      });
      
      // Fallback to FormIO if available
      if (this.package.formioId) {
        console.log('Falling back to FormIO form...');
        this.retriveClaimSubmissionId();
      }
    } finally {
      this.sharedService.hideLoading();
    }
  }

  /**
   * Sets up the message listener for Angeion form iframe communication (for logging/debugging)
   * Note: Actual submission handling is done via one-time listeners in submitAngeionForm()
   */
  private setupAngeionFormMessageListener(): void {
    // Remove any existing listener
    if (this.angeionFormMessageListener) {
      window.removeEventListener('message', this.angeionFormMessageListener);
    }

    // Create a listener for logging/debugging purposes
    this.angeionFormMessageListener = (event: MessageEvent) => {
      // Log ALL messages first - including timestamp to track when they arrive
      console.log('[Angeion Iframe Debug] ANY message on window at', new Date().toISOString(), {
        origin: event.origin,
        source: event.source,
        data: event.data,
        isFromOurIframe: event.source === this.angeionFormIframe?.contentWindow
      });
      
      // Verify the message is from our iframe
      if (!this.angeionFormIframe || event.source !== this.angeionFormIframe.contentWindow) {
        console.log('[Angeion Iframe Debug] Message ignored - not from our iframe');
        return;
      }

      const { type, success } = event.data ?? {};
      console.log('[Angeion Iframe Debug] Received message from OUR iframe:', { type, success, data: event.data });
      
      // Special logging for submit responses
      if (type === 'submit' || type === 'save' || Array.isArray(event.data)) {
        console.log('[Angeion Iframe Debug] ⚠️ SUBMIT RESPONSE DETECTED:', event.data);
      }
    };

    // Add the listener
    window.addEventListener('message', this.angeionFormMessageListener);
    console.log('Angeion form message listener set up');
  }

  /**
   * Cleans up the Angeion form iframe and message listener
   */
  private cleanupAngeionFormIframe(): void {
    // Remove message listener
    if (this.angeionFormMessageListener) {
      window.removeEventListener('message', this.angeionFormMessageListener);
      this.angeionFormMessageListener = null;
      console.log('Angeion form message listener removed');
    }

    // Remove iframe reference
    if (this.angeionFormIframe) {
      this.angeionFormIframe = null;
      console.log('Angeion form iframe reference cleared');
    }

    // Reset submission state
    this.angeionFormSubmissionPending = false;
    this.angeionFormSubmissionResolver = null;
    this.angeionFormSubmissionRejecter = null;
  }

  /**
   * Submits the Angeion form via iframe by posting a message
   * and waiting for the response.
   * Following the pattern provided by the Angeion team.
   */
  async submitAngeionForm(): Promise<any> {
    if (!this.angeionFormIframe) {
      throw new Error('Angeion form iframe not loaded');
    }
    
    // If there's already a pending submission, wait for it
    if (this.angeionFormSubmissionPending) {
      console.log('Submission already in progress, waiting...');
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (!this.angeionFormSubmissionPending) {
            clearInterval(checkInterval);
            resolve({ success: true });
          }
        }, 100);
        
        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error('Submission timeout'));
        }, 60000);
      });
    }
    
    console.log('Submitting Angeion form via iframe postMessage...');
    this.angeionFormSubmissionPending = true;
    
    // Get the origin from the iframe src for postMessage
    const iframeSrc = this.angeionFormIframe.src;
    // Use the pattern from Angeion team: split on '.com' to get origin
    const origin = iframeSrc.includes('.com') 
      ? iframeSrc.split('.com')[0] + '.com'
      : iframeSrc.match(/^(https?:\/\/[^\/]+)/)?.[1] || '*';
    
    console.log('Posting submit message to iframe, origin:', origin);
    
    // Create a promise with one-time message listener (following Angeion team's pattern)
    return new Promise((resolve, reject) => {
      // Set timeout for the submission
      const timeoutId = setTimeout(() => {
        window.removeEventListener('message', messageHandler);
        this.angeionFormSubmissionPending = false;
        reject(new Error('Form submission timeout'));
      }, 60000);
      
      // One-time message handler for this submission
      const messageHandler = (event: MessageEvent) => {
        console.log('[DEBUG] Message received:', {
          source: event.source,
          origin: event.origin,
          data: event.data,
          iframeContentWindow: this.angeionFormIframe?.contentWindow,
          sourceMatchesIframe: event.source === this.angeionFormIframe?.contentWindow
        });
        
        // Verify the message is from our iframe
        if (!this.angeionFormIframe || event.source !== this.angeionFormIframe.contentWindow) {
          console.log('[DEBUG] Message ignored - not from our iframe');
          return;
        }
        
        const data = event.data ?? {};
        const { type, success } = data;
        
        console.log('Received message from Angeion form iframe:', { type, success, data });
        
        // Accept any message from iframe after submit is posted
        // Don't filter by type - the iframe might send different message types
        console.log('[DEBUG] Processing response from iframe');
        
        // Clean up
        clearTimeout(timeoutId);
        window.removeEventListener('message', messageHandler);
        this.angeionFormSubmissionPending = false;
        
        // Check if it's a success response
        if (type === 'submit' && success === true) {
          console.log('Angeion form submitted successfully');
          this.isSubmitButtonEnabled = true;
          resolve(data);
        } else {
          // Treat any other response as rejection (including validation errors)
          console.log('Angeion form submission response (not success):', data);
          // Extract error message from response
          const errorMessage = data?.message || data?.error || data?.details?.reason || 
                              (Array.isArray(data) && data.length === 0 ? 'Form validation failed - please check all required fields' : 'Form validation failed');
          reject({ ...data, message: errorMessage });
        }
      };
      
      // Add the one-time listener BEFORE adding debug listener
      // Run outside Angular's zone to avoid zone.js interfering with postMessage
      console.log('[DEBUG] Adding message event listener for submit (outside Angular zone)');
      
      this.ngZone.runOutsideAngular(() => {
        window.addEventListener('message', messageHandler);
        console.log('[DEBUG] Listener added outside zone');
      });
      
      // Post the submit message to trigger form submission in iframe
      console.log('[DEBUG] Iframe details:', {
        iframe: this.angeionFormIframe,
        contentWindow: this.angeionFormIframe?.contentWindow,
        src: this.angeionFormIframe?.src,
        ready: this.angeionFormIframe?.contentWindow !== null
      });
      
      if (this.angeionFormIframe?.contentWindow) {
        console.log('[DEBUG] Posting submit message to iframe');
        this.angeionFormIframe.contentWindow.postMessage({ type: 'submit' }, origin);
        console.log('[DEBUG] Message posted successfully');
        
        // Force a test to see if ANY message comes back
        setTimeout(() => {
          console.log('[DEBUG] 5 seconds passed, checking if handler was called...');
          if (this.angeionFormSubmissionPending) {
            console.warn('[DEBUG] Still pending! No response received from iframe.');
          }
        }, 5000);
      } else {
        console.error('[DEBUG] Cannot post message - contentWindow is null!');
        clearTimeout(timeoutId);
        window.removeEventListener('message', messageHandler);
        this.angeionFormSubmissionPending = false;
        reject(new Error('Iframe contentWindow is not available'));
      }
    });
  }

  /**
   * Submits the Angeion form and then saves the package
   */
  async submitAngeionFormAndSave(hideToast: boolean, isBack: boolean) {
    try {
      this.sharedService.showLoading();
      
      // Submit the Angeion form first
      const formResponse = await this.submitAngeionForm();
      console.log('Angeion form submission response:', formResponse);
      
      // Show success message for form submission
      if (!hideToast) {
        this.sharedService.showToastMessage({
          message: 'Form saved successfully.',
          type: MessageType.success,
        });
      }
      
      // Continue with package save logic (without form submission)
      this.savePackageData(hideToast, isBack);
      
    } catch (error: any) {
      console.error('Error submitting Angeion form:', error);
      this.disableButtons = false;
      this.sharedService.hideLoading();
      
      // Show the error message from iframe (validation errors, etc.)
      const errorMessage = error?.message || error?.error || error?.details?.reason || 'Form submission failed. Please check the form for errors.';
      this.sharedService.showToastMessage({
        message: errorMessage,
        type: MessageType.error,
      });
    }
  }

  /**
   * Handles Angeion form submission for the onSubmit workflow
   */
  async handleAngeionSubmit(submitType: SubmitType) {
    try {
      this.sharedService.showLoading();
      
      // Submit the Angeion form
      const formResponse = await this.submitAngeionForm();
      console.log('Angeion form submission response:', formResponse);
      
      // Proceed to submission after save logic
      this.onSubmitAfterSave(submitType);
      
    } catch (error: any) {
      console.error('Error submitting Angeion form:', error);
      this.disableButtons = false;
      this.sharedService.hideLoading();
      
      // Show the error message from iframe (validation errors, etc.)
      const errorMessage = error?.message || error?.error || error?.details?.reason || 'Form submission failed. Please check the form for errors.';
      this.sharedService.showToastMessage({
        message: errorMessage,
        type: MessageType.error,
      });
    }
  }

  /**
   * Resets the Angeion form by reloading the iframe
   */
  async resetAngeionForm(): Promise<void> {
    if (!this.angeionFormIframe) {
      return;
    }
    
    try {
      console.log('Resetting Angeion form by reloading iframe...');
      // Reload the iframe to reset the form
      const currentSrc = this.angeionFormIframe.src;
      this.angeionFormIframe.src = currentSrc;
      console.log('Angeion form reset successfully');
    } catch (error) {
      console.error('Error resetting Angeion form:', error);
      throw error;
    }
  }

  /**
   * Checks if current form is an Angeion form
   */
  isAngeionForm(): boolean {
    return this.angeionFormType === 'angeion';
  }

  /**
   * Diagnostic function to test Angeion form iframe loading
   * Can be called from browser console for debugging
   */
  async testAngeionFormLoading(): Promise<void> {
    console.log('=== Angeion Form Iframe Loading Diagnostics ===');
    
    console.log('1. Form Configuration:');
    console.log('   - Form Type:', this.angeionFormType);
    console.log('   - Form Location:', this.angeionFormLocation);
    console.log('   - Form Name:', this.angeionFormName);
    console.log('   - Cache Key:', this.angeionFormCacheKey);
    
    console.log('2. Iframe Status:');
    console.log('   - Iframe exists:', !!this.angeionFormIframe);
    if (this.angeionFormIframe) {
      console.log('   - Iframe src:', this.angeionFormIframe.src);
    }
    
    console.log('3. Message Listener Status:');
    console.log('   - Listener attached:', !!this.angeionFormMessageListener);
    
    console.log('4. Submission Status:');
    console.log('   - Submission pending:', this.angeionFormSubmissionPending);
    
    console.log('5. Testing URL accessibility...');
    try {
      await fetch(this.angeionFormLocation, { method: 'HEAD', mode: 'no-cors' });
      console.log('   ✓ URL appears to be accessible');
    } catch (error) {
      console.log('   ✗ URL accessibility test failed:', error);
    }
    
    console.log('=== End Diagnostics ===');
  }
}